import { Box, Flex, Text } from '@chakra-ui/react';
import {
  faCircleCheck,
  faTriangleExclamation
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Link } from '@morressier/alembic';
import { SubmissionFlowLayout } from './components/SubmissionFlowLayout';
import { useNavigate } from 'react-router-dom';

interface Props {
  goToFirstStep: () => void;
  submissionId: string;
  manuscriptId: string;
}

const SuccessStep: React.FC<Props> = ({
  goToFirstStep,
  submissionId,
  manuscriptId
}) => {
  const navigate = useNavigate();
  const restartFlow = () => {
    goToFirstStep();
  };

  return (
    <SubmissionFlowLayout width="720px">
      <Flex
        height="112px"
        width="100%"
        background={submissionId ? 'successSecondaryFill' : 'errorPrimaryFill'}
        justifyContent="center"
        alignItems="center"
        borderRadius="base"
        color={
          submissionId
            ? 'successPrimaryContentAccent'
            : 'actionPrimaryCautionBorderHover'
        }
        marginBottom={8}
      >
        <FontAwesomeIcon
          fontSize={40}
          icon={submissionId ? faCircleCheck : faTriangleExclamation}
        />
      </Flex>

      <Box textAlign="center" marginBottom={8}>
        <Text textStyle="headingTitle" marginBottom={2}>
          {submissionId ? 'Paper Submitted' : 'Submission Failed'}
        </Text>
        {manuscriptId ? (
          <Link
            variant="primary"
            marginBottom={2}
            fontWeight="bold"
            onClick={() =>
              navigate(`/app/my-submissions/${submissionId}`, {
                state: { fromSubmission: true }
              })
            }
          >
            Manuscript ID : {manuscriptId}
          </Link>
        ) : null}
        <Text>
          {submissionId
            ? `Thank you for submitting your manuscript. You will receive an email confirmation, and our editorial team will review your submission.`
            : `Failed to submit your manuscript. Please try again later or contact support.`}
        </Text>
      </Box>

      <Flex justifyContent="center" gap={2}>
        <Button variant="secondary" onClick={restartFlow}>
          Submit Another Paper
        </Button>
        {submissionId ? (
          <Button
            variant="primary"
            onClick={() => {
              navigate(`/app/my-submissions?submissionType=my-submissions-active&searchParams=${manuscriptId}`);
            }}
          >
            View in My Submissions
          </Button>
        ) : null}
      </Flex>
    </SubmissionFlowLayout>
  );
};

export default SuccessStep;
